import { fetchUtils } from 'react-admin'
import mjml from 'mjml-browser'
import { JsonToMjml } from 'easy-email-core'

const apiUrl = process.env.REACT_APP_BACKEND_API // TODO

export const onUploadImage = async (blob) => {
  const httpClient = fetchUtils.fetchJson
  console.log('image blob', blob)

  const buildAuthHeaders = () => {
    const token = localStorage.getItem('auth')
    const headers = new Headers({ Accept: 'application/json', auth: token })

    return headers
  }

  const formData = new FormData()
  formData.append('file', blob)

  const headers = buildAuthHeaders()
  const middlewareId = 'media/assets' // TODO media/emailImages
  const { json } = await httpClient(`${apiUrl}/${middlewareId}`, {
    headers,
    method: 'POST',
    body: formData,
  })

  const { url } = json

  console.log('url', url)

  return url
}

export const convertToHTML = (values, mergeTags) => {
  const mjmlString = JsonToMjml({
    data: values.content,
    mode: 'production',
    context: values.content,
    dataSource: mergeTags,
  })

  const html = mjml(mjmlString, {}).html
  return html
}

export const convertToJSON = (values) => {
  const stringifyTemplate = JSON.stringify(values, null, 2)
  return stringifyTemplate
}
